/**
 * Images live on a plain CDN with no transforms, so full-size files (1.5 MB+) were
 * being downloaded for slots a few hundred pixels wide. These helpers route them
 * through a resizing image proxy that returns compressed WebP at the needed width.
 */
const PROXY = 'https://wsrv.nl/'

export const IMAGE_ORIGIN = 'https://wsrv.nl'

export function optimizedImage(src: string, width: number, quality = 62): string {
  return `${PROXY}?url=${encodeURIComponent(src)}&w=${width}&output=webp&q=${quality}&af&il`
}

export function optimizedSrcSet(src: string, widths: number[], quality = 62): string {
  return widths.map((width) => `${optimizedImage(src, width, quality)} ${width}w`).join(', ')
}

// The bundle mockup is the LCP element. Candidates are tuned to the real rendered
// box (max 512 CSS px on phones, 576 px from sm up) instead of over-serving pixels.
export const HERO_WIDTHS = [360, 480, 640, 840]
export const HERO_SIZES = '(max-width: 640px) 88vw, 576px'

export const OFFER_WIDTHS = [320, 440, 620]
export const OFFER_SIZES = '(max-width: 640px) 86vw, 420px'

export const BONUS_WIDTHS = [200, 300, 400]
export const BONUS_SIZES = '(max-width: 640px) 62vw, (max-width: 1024px) 30vw, 220px'
